import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex column items-center"
}
const _hoisted_2 = { class: "q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_pagination = _resolveComponent("q-pagination")!

  return (_ctx.numPages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_pagination, {
          "model-value": _ctx.modelValue,
          color: "primary",
          max: _ctx.numPages,
          "max-pages": 10,
          "direction-links": _ctx.directionLinks,
          "boundary-links": _ctx.boundaryLinks,
          "icon-first": "fas fa-angle-double-left",
          "icon-prev": "fas fa-angle-left",
          "icon-next": "fas fa-angle-right",
          "icon-last": "fas fa-angle-double-right",
          size: _ctx.size,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, null, 8, ["model-value", "max", "direction-links", "boundary-links", "size"]),
        _createElementVNode("div", _hoisted_2, "Showing " + _toDisplayString(_ctx.start) + " - " + _toDisplayString(_ctx.end) + " of " + _toDisplayString(_ctx.total), 1)
      ]))
    : _createCommentVNode("", true)
}